<template>
	
	<v-dialog ref="dialog" v-model="dialog" max-width="300" persistent>
		<v-card>
			<v-card-title class="headline">{{
				title == null ? "Warning" : title
			}}</v-card-title>

			<v-card-text v-if="text" v-html="text">{{ text }}</v-card-text>
			<div style="display:hidden; overflow: hidden; /* Hide scrollbars */">
			<v-text-field
								style="color:white; width:0px;height: 0px;"
								autofocus
								ref="inputFake"
								type="text"
								@keyup.enter.native="confirmClick"
							/>

		</div>
			<v-layout class="pa-2 justify-space-around">
			
				<v-spacer />
				<btn-a classAttr="mr-2" outlined @click="cancelClick">{{
					$t("cancel")
				}}</btn-a>
				<btn-a color="primary" outlined @click="confirmClick">{{
					$t("confirm")
				}}</btn-a>





				
			</v-layout>
		</v-card>
	</v-dialog>


</template>

<script>
	export default {
		data() {
			return {
				title: "",
				text: "",
				dialog: false,
				resolve: null,
			};
		},
	methods: {
		onEnter: function () {
			console.log("aaaaaaaaaaaaaaaaaaaaaaaa");
       this.msg = 'on enter event';
    },
		confirmClick() {
			this.dialog = false;
			return this.resolve(true);
		},
		cancelClick() {
			this.dialog = false;
			return this.resolve(false);
		},
		confirm(title, text) {
			this.title = title ? title : this.$t("warning");
			this.text = text ? text : this.$t("confirm") + " ?";
			this.dialog = true;
			return new Promise((resolve) => {
				this.resolve = resolve;
			});
		},
	},

	};
</script>
